import { render, staticRenderFns } from "./ligature_echo.vue?vue&type=template&id=16a8c542&scoped=true"
import script from "./ligature_echo.vue?vue&type=script&lang=js"
export * from "./ligature_echo.vue?vue&type=script&lang=js"
import style0 from "./ligature_echo.vue?vue&type=style&index=0&id=16a8c542&prod&scoped=true&lang=scss"
import style1 from "./ligature_echo.vue?vue&type=style&index=1&id=16a8c542&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8c542",
  null
  
)

export default component.exports